/**
 * Public G2 review stats (update when G2 profile changes).
 * Used in blog trust blocks, JSON-LD, and AI-facing copy.
 */
export const G2_PUBLIC_STATS = {
  ratingValue: '5.0',
  bestRating: '5',
  reviewCountMinimum: 20,
  reviewCountLabel: '20+',
  badgeTitle: 'Users Love Us',
}

/** Official G2-hosted badge (Content Hub → G2 Badges → Users Love Us). */
export const G2_USERS_LOVE_US_BADGE_SRC =
  'https://www.g2.com/shared-assets/product-badges/users-love-us.svg'
export const G2_USERS_LOVE_US_REVIEWS_URL =
  'https://www.g2.com/products/prime-document-sign/reviews?utm_source=rewards-medal'
export const G2_USERS_LOVE_US_BADGE_ALT = 'Users Love Us'
/** Official JSON-LD payload used by G2 badge embeds. */
export const G2_RATING_SCHEMA_URL =
  'https://www.g2.com/products/prime-document-sign/rating_schema.json'
